import React from "react";
import { Link } from "react-router-dom";

const ShareAndFindItem = ({ item }) => {
  const { img, title, example, id } = item;
  console.log(img);
  const style = {
    backgroundImage: `url(${img})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "250px",
  };
  return (
    <div className="col-md-6 col-lg-3 mt-5">
      <div className="shareFindContainer" style={style}>
        <div className="shareFindContainerChild">
          <h5 className="shareFind_title">{title}</h5>
          <p className="shareFindP">{example}</p>
          <Link to={`/category/${id}`}>
            <button className="shareFindBtn">Explore More</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ShareAndFindItem;
